import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';
import { athensGray2 } from 'constants/colors';
import NFTCard from 'icons/NFTCard.svg';

export const useStyles = makeStyles()((theme: Theme) => {
  return {
    root: {
      width: 286,
      height: 429,

      maxWidth: '100%',

      backgroundImage: `url(${NFTCard})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center top',

      '& .MuiCardActionArea-root': {
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      },
      '& .MuiCardContent-root': {
        width: '100%',
        padding: '0',
        '& svg, & .MuiAvatar-root': {
          width: 24,
          height: 24,
        },
      },

      // micro card
      '&.micro': {
        minWidth: 136,
        height: 249,

        '& .ReactPlayer': {
          maxHeight: '124px!important',
        },

        '& .MuiTypography-root': {
          fontSize: '1.2rem',
        },

        '& .MuiCardActionArea-root': {
          padding: 5,
        },
        '& .MuiCardContent-root': {
          padding: 0,
          '& svg, & .MuiAvatar-root': {
            width: 12,
            height: 12,
          },
        },
        '& div[class*="-exclusive"]': {
          '& .MuiTypography-root': {
            fontSize: '1.2rem',
          },
        },
        '& div[class*="-ownerBox"]': {
          '& .MuiAvatar-root': {
            alignSelf: 'flex-start',
            marginTop: '3px',
          },
          '& .MuiTypography-root': {
            marginTop: 0,
            overflow: 'visible',
            whiteSpace: 'break-spaces',
            wordBreak: 'break-word',
            color: '#828282',

            '&[class*="-title"]': {
              display: 'none',
            },
          },
        },

        [theme.breakpoints.up('sm')]: {
          width: 286,
          height: 429,

          '& .ReactPlayer': {
            maxHeight: '100%!important',
          },

          '& .MuiCardActionArea-root': {
            padding: 10,
          },
          '& .MuiTypography-root': {
            fontSize: '1.6rem',
          },
          '& .MuiCardContent-root': {
            padding: 0,
            '& svg, & .MuiAvatar-root': {
              width: 24,
              height: 24,
              minWidth: 24,
            },
          },
          '& div[class*="-ownerBox"]': {
            '& .MuiAvatar-root': {
              alignSelf: 'center',
              marginTop: 0,
            },
            '& .MuiTypography-root': {
              fontSize: '1.4rem',
              overflow: 'visible',
              whiteSpace: 'nowrap',
              wordBreak: 'initial',
              color: '#000000',

              '&[class*="-title"]': {
                display: 'block',
              },
              '&[class*="-creatorName"]': {
                marginTop: '4px',
              },
            },
          },
        },
      },
    },
    disabledCard: {
      '&:hover': { cursor: 'not-allowed' },
    },
    checkbox: {
      position: 'absolute',
      right: 12,
      top: 12,
      borderRadius: 5,
      height: 25,
      width: 25,
      zIndex: 1,
      color: '#828282',
      '&.Mui-checked': {
        color: '#3889FA',
      },
    },
    blur: {
      filter: 'blur(10px) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
    },
    mediaWrap: {
      width: 259,
      height: 259,

      maxWidth: '100%',

      '&.micro': {
        minWidth: 126,
        height: 124,
        [theme.breakpoints.up('sm')]: {
          width: 259,
          height: 259,
        },
      },
    },
    img: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    video: {
      maxHeight: 124,
      borderBottom: `1px solid ${athensGray2}`,

      [theme.breakpoints.up('sm')]: {
        maxWidth: '100%',
        maxHeight: 'initial',
      },
    },
    previewLoader: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginLeft: -20,
      marginTop: -20,
    },
    contentTitle: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    exclusive: {
      width: 100,
      background: `#FFFFFF`,
      border: '1px solid #E0E0E0',
      borderRadius: 30,
      padding: '3px 0',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      position: 'absolute',
      top: '16px',
      left: '16px',
      zIndex: 1,

      '& svg': {
        marginRight: 12,
        height: 14,
        width: 14,
      },

      '& .MuiTypography-root': {
        color: '#62B4D8',
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: '1.2rem',
      },
    },
    amountOfCopies: {
      color: '#828282 !important',
    },
    title: {
      color: '#828282 !important',
      marginBottom: '0 !important',
      fontSize: '1.4rem',
    },
    creatorName: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      color: '#000000',
      fontWeight: 600,
      fontSize: '1.4rem',
    },
    priceBox: {
      marginTop: '10px',
      minHeight: '34px',

      '& .MuiTypography-root': {
        whiteSpace: 'nowrap',
        color: '#3889FA',
        padding: '4px 10px',
        background: '#FFFFFF',
        borderRadius: 20,

        display: 'flex',
      },
    },
  };
});
